import React from 'react';

const HeroContent = ({ heroProfile }) => {
  const content = heroProfile; // Obtiene el contenido según el idioma

  return (
    <div className="home-hero__content">
      <h1 className="heading-primary">{content.heading}</h1>
      <div className="home-hero__info">
        <p className="text-primary">{content.description}</p>
      </div>
      <div className="home-hero__cta">
        <a href={content.ctaLink} className="btn btn--bg">
          {content.ctaText}
        </a>
      </div>
    </div>
  );
};

export default HeroContent;